import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { baseUrl, baseimgUrl } from "../Univ";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import AlsoBought from "./AlsoBought";

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [customerPincode, setCustomerPincode] = useState(null);
  const [deliveryDays, setDeliveryDays] = useState(2); // base 2 days
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
const isLoggedIn = localStorage.getItem("userGroup") === "Customer";
const navigate = useNavigate();
const fetchUserPincode = async () => {
  const userId = localStorage.getItem("user_id");

  if (!userId) return;

  try {
    const res = await axios.get(baseUrl + `users/${userId}/`);
    setCustomerPincode(res.data.pincode);
  } catch (err) {
    console.error("Failed to fetch user pincode");
  }
};

  // ---------------------------
  // FETCH PRODUCT & REVIEWS
  // ---------------------------
  useEffect(() => {
    fetchProduct();
    fetchReviews();
    fetchUserPincode();
  }, []);

  const fetchProduct = async () => {
    const res = await axios.get(baseUrl + `products/${id}/`);
    setProduct(res.data);
  };

useEffect(() => {

  if (!product || !customerPincode) return;
  const sellerPin = product.seller?.pincode;

  if (!sellerPin) {
    console.warn("❌ Seller pincode missing");
    return;
  }
  const diff = Math.abs(
    Number(sellerPin) - Number(customerPincode)
  );
  const extraDays = Math.floor(diff / 100);
  const totalDays = 2 + extraDays;
  setDeliveryDays(totalDays);

}, [product, customerPincode]);

  const fetchReviews = async () => {
    const res = await axios.get(baseUrl + `product-reviews/${id}/`);
    setReviews(res.data);

    if (res.data.length > 0) {
      const total = res.data.reduce((sum, r) => sum + r.rating, 0);
      setAverageRating((total / res.data.length).toFixed(1));
      setTotalReviews(res.data.length);
    } else {
      setAverageRating(0);
      setTotalReviews(0);
    }
  };

  function StarRating({ rating }) {
    const totalStars = 5;
    const filledStars = Math.round(rating);
    const stars = [];
    for (let i = 1; i <= totalStars; i++) {
      stars.push(
        <span key={i} style={{ color: "#FFA41C", fontSize: "20px" }}>
          {i <= filledStars ? "★" : "☆"}
        </span>
      );
    }
    return <>{stars}</>;
  }
  useEffect(() => {
    setIsLoading(true);
    axios.get(baseUrl + "categories/")
      .then(res => {
        setCategories(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  // ---------------- BUILD BREADCRUMBS ----------------
  const buildBreadcrumbs = (categoryId) => {
    const path = [];
    let current = categories.find(c => c.id === categoryId);

    while (current) {
      path.unshift(current.name);
      current = current.parent ? categories.find(c => c.id === current.parent) : null;
    }

    return path.join(" › ");
  };

  if (!product || isLoading) return <h4>Loading...</h4>;

  // ---------------------------
  // ADD TO CART / WISHLIST / COMPARE
  // ---------------------------
  const addToCart = async (pid) => {
      if (!isLoggedIn) {
      navigate("/user-login");
      return;
    }

    await axios.post(baseUrl + "add-cart/", { product_id: pid || id, quantity });
    alert("Added to cart");
  };

  const addWishlist = async (pid) => {
      if (!isLoggedIn) {
      navigate("/user-login");
      return;
    }

    await axios.post(baseUrl + "add-wishlist/", { product_id: pid || id });
    alert("Added to wishlist");
  };



  // ---------------------------
  // SUBMIT REVIEW
  // ---------------------------
  const submitReview = async () => {
    await axios.post(baseUrl + "add-review/", { product: id, rating, comment });
    setComment("");
    fetchReviews();
  };

  if (!product) return <h4>Loading...</h4>;

  // ---------------------------
// State for categories
// ---------------------------
  // ---------------- FETCH CATEGORIES ----------------

  return (
    <div className="container mt-4">

      {/* BREADCRUMBS */}
      <div className="mb-2 text-muted">
        {product.category ? buildBreadcrumbs(product.category) : "Uncategorized"}
      </div>
      <div className="row">

        {/* IMAGES */}
        <div className="col-md-5">
          <div className="card shadow-sm h-100">
            <Carousel showThumbs useKeyboardArrows dynamicHeight infiniteLoop>
              {product.images && product.images.length > 0 ? (
                product.images.map((img, i) => (
                  <div key={i}>
                    <img
                      src={`${img.image}`}
                      alt={product.name}
                      style={{ objectFit: "contain", maxHeight: "400px" }}
                    />
                  </div>
                ))
              ) : (
                <div>
                  <img
                    src="https://via.placeholder.com/400x300?text=No+Image"
                    alt="No Image"
                  />
                </div>
              )}
            </Carousel>
          </div>
        </div>

        {/* PRODUCT DETAILS */}
        <div className="col-md-7">

          <h3>{product.name}</h3>

          <div className="mb-2">
            <h4 className="text-success d-inline me-2">
              ₹{product.discount_price || product.price}
            </h4>
            {product.discount_price && (
              <span className="text-muted text-decoration-line-through">
                ₹{product.price}
              </span>
            )}
          </div>

          <div className="mt-2 mb-3">
            <StarRating rating={averageRating} />
            <span className="ms-2">({totalReviews.toLocaleString()} reviews)</span>
          </div>

          <div className="mb-2">
            <small className="text-success">
              FREE delivery in {deliveryDays} day{deliveryDays > 1 ? "s" : ""}
            </small>
          </div>

          <div className="mb-3">
            <label>Quantity: </label>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              className="form-control d-inline-block w-auto ms-2"
            />
          </div>

          <div className="mb-3 d-flex gap-2">
            <button className="icon-btn cart-btn" onClick={() => addToCart(product.id)}>
              <i className="fa-solid fa-cart-shopping"></i>
            </button>
            <button className="icon-btn wish-btn" onClick={() => addWishlist(product.id)}>
              <i className="fa-regular fa-heart"></i>
            </button>
          </div>

          <p>Sold by: <strong>{product.seller?.shop_name || "Our Store"}</strong></p>
          <p>Gift options available at checkout</p>

          {product.offers?.length > 0 && (
            <div className="mb-2">
              <h6>Offers:</h6>
              <ul>
                {product.offers.map((o, idx) => (
                  <li key={idx}>{o}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

      </div>

      {/* REVIEWS */}
      <div className="mt-5">
        <h4>Customer Reviews</h4>
        <div className="mt-2 mb-3">
          <StarRating rating={averageRating} />
          <span className="ms-2">({totalReviews.toLocaleString()} reviews)</span>
        </div>

        {reviews.map((r) => (
          <div key={r.id} className="border p-2 mb-2">
            <strong>{r.user.username}</strong>
            <span className="ms-2">⭐ {r.rating}</span>
            <p>{r.comment}</p>
          </div>
        ))}
{isLoggedIn && (
  <>
        <div className="mt-3">
          <h5>Add Review</h5>
          <select className="form-select mb-2" value={rating} onChange={(e) => setRating(Number(e.target.value))}>
            {[5,4,3,2,1].map(n => <option key={n} value={n}>{n} Star</option>)}
          </select>

          <textarea className="form-control mb-2" placeholder="Write review..." value={comment} onChange={(e) => setComment(e.target.value)} />
          <button className="btn btn-primary" onClick={submitReview}>Submit Review</button>

        </div>
              </>
)}

      </div>
{isLoggedIn && (
  <>
      {/* ALSO BOUGHT */}
      <AlsoBought productId={id} />
</>
)}
    </div>
  );
}

export default ProductDetails;
